module.exports = __webpack_public_path__ + "05_glasses_brown.1984ab94.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer4/05_glasses_brown.png
// module id = a8Zf
// module chunks = 0